import React, { useState, useEffect } from 'react';

const ConsiglioDirectivo = () => {
  const [animatedItems, setAnimatedItems] = useState([]);

  // Add custom CSS for animations
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes float {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-15px); }
      }
      .animate-float {
        animation: float 6s ease-in-out infinite;
      }
      @keyframes pulse {
        0%, 100% { opacity: 0.1; }
        50% { opacity: 0.3; }
      }
      .animate-pulse {
        animation: pulse 4s ease-in-out infinite;
      }
      @keyframes slideUp {
        from { transform: translateY(20px); opacity: 0; }
        to { transform: translateY(0); opacity: 1; }
      }
      .animate-slideUp {
        animation: slideUp 0.5s ease-out forwards;
      }
    `;
    document.head.appendChild(style);
    
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setAnimatedItems(prev => [...prev, entry.target.id]);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.animate-on-scroll').forEach(item => {
      observer.observe(item);
    });

    return () => {
      document.querySelectorAll('.animate-on-scroll').forEach(item => {
        observer.unobserve(item);
      });
    };
  }, []);

  // Real data for board members
  const boardMembers = [
    {
      id: 1,
      name: 'Fiorina Giona',
      role: 'Presidente',
      bio: 'Rapporti con le Istituzioni e con le altre Associazioni di volontariato',
      color: '#5AB45A',
      icon: 'M3 3h18v18H3V3zm9 4.5L7.5 12 12 16.5l4.5-4.5L12 7.5z'
    },
    {
      id: 2,
      name: 'Danila Gallotti',
      role: 'Vicepresidente',
      bio: 'Coordina le attività operative dell\'associazione e supporta la Presidente nelle sue funzioni.',
      color: '#E63129',
      icon: 'M12 2L2 12h3v8h14v-8h3L12 2zm0 7.5c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5z'
    },
    {
      id: 3,
      name: 'Elisabetta Ghirlanda',
      role: 'Tesoriere',
      bio: 'Responsabile del supporto amministrativo e gestionale dell\'Associazione e del rapporto con i soci',
      color: '#E63129',
      icon: 'M3.94 5.13l8.11 4.68c.05.03.1.05.15.05s.09-.02.14-.05l8.11-4.68a.46.46 0 00.04-.79L12.29.05a.46.46 0 00-.58 0L3.9 4.34a.46.46 0 00.04.79zm8.26 6.53l-6.48-3.75-2.68 1.55c-.28.16-.28.56 0 .72l8.11 4.68c.05.03.1.05.15.05s.09-.02.14-.05l8.11-4.68a.46.46 0 000-.72l-2.68-1.55-6.48 3.75a.46.46 0 01-.58 0zm0 4l-6.48-3.75-2.68 1.55c-.28.16-.28.56 0 .72l8.11 4.68c.05.03.1.05.15.05s.09-.02.14-.05l8.11-4.68a.46.46 0 000-.72l-2.68-1.55-6.48 3.75a.46.46 0 01-.58 0z'
    },
    {
      id: 4,
      name: 'Maria Barbara Cavallo',
      role: 'Segretario',
      bio: 'Responsabile del supporto giuridico',
      color: '#5AB45A',
      icon: 'M10 4h4v4h-4V4zm0 6h4v4h-4v-4zm-6-6h4v4H4V4zm0 6h4v4H4v-4z'
    },
    {
      id: 5,
      name: 'Pierluigi Girolami',
      role: 'Consigliere',
      bio: 'Coordinamento eventi e pubblicizzazione dell\'Associazione, Raccolta fondi',
      color: '#E63129',
      icon: 'M19.071 4.929a10 10 0 10-14.142 14.142 10 10 0 0014.142-14.142zm-7.071 9.071a4 4 0 110-8 4 4 0 010 8z'
    },
    {
      id: 6,
      name: 'Silvia Finocchi',
      role: 'Consigliere',
      bio: 'Coordinamento del gruppo per il benessere psicologico',
      color: '#E63129',
      icon: 'M2 2h5v5H2V2zm0 11h5v5H2v-5zm11 0h5v5h-5v-5zm0-11h5v5h-5V2z'
    },
    {
      id: 7,
      name: 'Claudio Cherin',
      role: 'Consigliere',
      bio: 'Coordinamento sito web e social',
      color: '#5AB45A',
      icon: 'M18 3a2 2 0 012 2v10a2 2 0 01-2 2H6a2 2 0 01-2-2V5a2 2 0 012-2h12zm-2 5a1 1 0 10-2 0v6a1 1 0 102 0V8zM8 9a1 1 0 011 1v4a1 1 0 11-2 0v-4a1 1 0 011-1zm4-3a1 1 0 00-1 1v6a1 1 0 102 0V7a1 1 0 00-1-1z'
    }
  ];

  return (
    <>
      <div className="py-12 bg-gray-50">
        {/* Header Section */}
        <div className="container mx-auto px-4 mb-12 animate-on-scroll" id="header-section">
          <h1 className={`text-4xl md:text-5xl font-bold text-center text-accent mb-4 ${animatedItems.includes('header-section') ? 'animate-fadeIn' : 'opacity-0'}`}>Consiglio Direttivo</h1>
          <div className="w-32 h-1 bg-gradient-to-r from-primary via-accent to-accent mx-auto mb-8 rounded-full"></div>
          <p className={`text-xl text-gray-700 text-center max-w-3xl mx-auto ${animatedItems.includes('header-section') ? 'animate-slideUp delay-300' : 'opacity-0 translate-y-10'}`}>
            Il nostro Consiglio Direttivo è composto da esperti nel campo medico, volontari e genitori che hanno esperienza diretta con malattie ematologiche rare. Insieme, guidano la nostra associazione verso il raggiungimento della nostra missione di supporto, educazione e ricerca.
          </p>
        </div>

        {/* Board Members Grid */}
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {boardMembers.map((member, index) => (
              <div 
                key={member.id} 
                id={`member-${member.id}`}
                className={`bg-white rounded-xl shadow-xl overflow-hidden animate-on-scroll transform transition-all duration-500 hover:shadow-2xl hover:-translate-y-2 group ${animatedItems.includes(`member-${member.id}`) ? 'animate-fadeInUp' : 'opacity-0 translate-y-10'}`}
                style={{ animationDelay: `${index * 150}ms` }}
              >
                <div className="relative h-64">
                  <div 
                    className="w-full h-full flex items-center justify-center overflow-hidden" 
                    style={{ backgroundColor: member.color }}
                  >
                    {/* Background patterns */}
                    <div className="absolute inset-0 opacity-10">
                      <div className="absolute w-60 h-60 rounded-full border-4 border-white/30 -top-20 -left-20"></div>
                      <div className="absolute w-40 h-40 rounded-full border-4 border-white/30 bottom-10 right-10"></div>
                    </div>
                    
                    {/* Main geometric shape */}
                    <div 
                      className="w-36 h-36 bg-white/30 flex items-center justify-center backdrop-blur-sm group-hover:scale-110 group-hover:rotate-12 transition-all duration-700 z-10"
                      style={{ 
                        clipPath: index % 3 === 0 ? 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)' : 
                                  index % 3 === 1 ? 'polygon(20% 0%, 80% 0%, 100% 20%, 100% 80%, 80% 100%, 20% 100%, 0% 80%, 0% 20%)' : 
                                  'circle(50% at 50% 50%)'
                      }}
                    >
                      <div className="w-28 h-28 flex items-center justify-center" style={{ 
                        backgroundColor: `${member.color}`, 
                        clipPath: index % 3 === 0 ? 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)' : 
                                  index % 3 === 1 ? 'polygon(20% 0%, 80% 0%, 100% 20%, 100% 80%, 80% 100%, 20% 100%, 0% 80%, 0% 20%)' : 
                                  'circle(50% at 50% 50%)'
                      }}>
                        <svg className="w-16 h-16 text-white transform transition-all duration-500 group-hover:rotate-45" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path d={member.icon} />
                        </svg>
                      </div>
                    </div>
                    <div 
                      className="absolute top-0 right-0 m-4 bg-white/20 backdrop-blur-sm p-2 transition-all duration-300 hover:bg-white/40 hover:scale-110"
                      style={{ 
                        clipPath: 'polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)'
                      }}>
                      <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent py-4 px-6">
                    <h3 className="text-xl font-bold text-white group-hover:translate-x-2 transition-transform duration-300">{member.name}</h3>
                    <p className="text-white/80 text-sm">{member.role}</p>
                  </div>
                </div>
                <div className="p-6">
                  <p className="text-gray-600 leading-relaxed">{member.bio}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Values Section */}
        <div className="container mx-auto px-4 mt-16 animate-on-scroll" id="values-section">
          <h2 className={`text-3xl font-bold text-center text-accent mb-4 ${animatedItems.includes('values-section') ? 'animate-fadeIn' : 'opacity-0'}`}>I Nostri Valori</h2>
          <div className="w-32 h-1 bg-gradient-to-r from-primary via-accent to-accent mx-auto mb-8 rounded-full"></div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
            <div className="bg-white p-6 rounded-lg shadow text-center transform transition-all duration-500 hover:shadow-xl hover:-translate-y-1">
              <div className="w-20 h-20 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-4 transform transition-all duration-300 group-hover:scale-110">
                <svg className="w-10 h-10 text-accent" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2 text-accent">Compassione</h3>
              <p className="text-gray-600">Agiamo con empatia e comprensione verso i pazienti e le loro famiglie.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow text-center transform transition-all duration-500 hover:shadow-xl hover:-translate-y-1">
              <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4 transform transition-all duration-300 group-hover:scale-110">
                <svg className="w-10 h-10 text-primary" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" d="M18 13V5a2 2 0 00-2-2H4a2 2 0 00-2 2v8a2 2 0 002 2h3l3 3 3-3h3a2 2 0 002-2zM5 7a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1zm1 3a1 1 0 100 2h3a1 1 0 100-2H6z" clipRule="evenodd" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2 text-primary">Trasparenza</h3>
              <p className="text-gray-600">Operiamo con onestà e integrità in tutte le nostre attività e comunicazioni.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow text-center transform transition-all duration-500 hover:shadow-xl hover:-translate-y-1">
              <div className="w-20 h-20 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-4 transform transition-all duration-300 group-hover:scale-110">
                <svg className="w-10 h-10 text-accent" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 3.5a1.5 1.5 0 013 0V4a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-.5a1.5 1.5 0 000 3h.5a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-.5a1.5 1.5 0 00-3 0v.5a1 1 0 01-1 1H6a1 1 0 01-1-1v-3a1 1 0 00-1-1h-.5a1.5 1.5 0 010-3H4a1 1 0 001-1V6a1 1 0 011-1h3a1 1 0 001-1v-.5z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2 text-accent">Innovazione</h3>
              <p className="text-gray-600">Cerchiamo continuamente nuovi modi per migliorare la vita dei pazienti e delle loro famiglie.</p>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        {/* Call to Action */}
        <div className="container mx-auto px-4 mt-16 mb-12 animate-on-scroll" id="cta-section">
          <div className={`bg-gradient-to-r from-primary via-accent to-accent text-white rounded-xl shadow-2xl overflow-hidden relative py-12 px-6 text-center max-w-4xl mx-auto transform transition-all duration-500 hover:shadow-[0_10px_40px_rgba(0,0,0,0.3)] ${animatedItems.includes('cta-section') ? 'animate-fadeIn' : 'opacity-0'}`}>
            {/* Decorative elements */}
            <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
              <div className="absolute -top-12 -left-12 w-64 h-64 rounded-full bg-white opacity-10 animate-pulse"></div>
              <div className="absolute top-40 -right-16 w-48 h-48 rounded-full bg-white opacity-10 animate-float"></div>
              <div className="absolute bottom-0 left-1/4 w-32 h-32 rounded-full bg-white opacity-10 animate-pulse" style={{ animationDelay: '1s' }}></div>
            </div>
            
            <h2 className="text-3xl md:text-4xl font-bold mb-6 relative animate-slideUp">Unisciti a Noi</h2>
            <p className="text-xl mb-8 max-w-2xl mx-auto relative animate-slideUp" style={{ animationDelay: '200ms' }}>
              Vuoi contribuire alla nostra missione? Diventa volontario o fai una donazione per supportare il nostro lavoro con chi ne ha più bisogno.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4 relative z-10">
              <a 
                href="/sostienici" 
                className="group bg-white font-bold py-3 px-8 rounded-full shadow-lg transition-all duration-300 transform hover:translate-y-[-5px] hover:shadow-xl hover:scale-105 relative overflow-hidden"
              >
                <span className="relative z-10 bg-gradient-to-r from-primary to-accent inline-block text-transparent bg-clip-text font-bold transition-all duration-300 group-hover:opacity-90">Fai una Donazione</span>
                <span className="absolute bottom-0 left-0 w-full h-[2px] bg-gradient-to-r from-primary to-accent transform origin-left scale-x-0 transition-transform duration-300 group-hover:scale-x-100"></span>
              </a>
              <a 
                href="/contatti" 
                className="group bg-transparent border-2 border-white text-white font-bold py-3 px-8 rounded-full shadow-lg transition-all duration-300 transform hover:bg-white hover:text-accent hover:border-transparent hover:translate-y-[-5px] hover:shadow-xl"
              >
                <span className="relative z-10">Contattaci</span>
              </a>
            </div>
          </div>
        </div>

        {/* Scientific Committee Section */}
        {/* <div className="container mx-auto px-4 mt-16 mb-12 animate-on-scroll" id="scientific-committee-section">
          <h2 className={`text-3xl font-bold text-center text-accent mb-4 ${animatedItems.includes('scientific-committee-section') ? 'animate-fadeIn' : 'opacity-0'}`}>IL NOSTRO COMITATO SCIENTIFICO</h2>
          <div className="w-32 h-1 bg-gradient-to-r from-primary via-accent to-accent mx-auto mb-8 rounded-full"></div>
          <p className={`text-xl text-gray-700 text-center max-w-3xl mx-auto ${animatedItems.includes('scientific-committee-section') ? 'animate-slideUp delay-300' : 'opacity-0 translate-y-10'}`}>
            Il nostro Comitato Scientifico è composto da esperti che forniscono consulenza e orientamento nelle attività dell'associazione.
          </p>
        </div> */}
      </div>
    </>
  );
};

export default ConsiglioDirectivo;

